import { Investment } from "@bn/api/apiv1";

export const investmentToSecurityImagePayload = (investment: Investment) => ({
  hasValidIsin: true,
  type: investment.quoteProvider === "currency" ? "81_fcurr" : "11_stock",
  isin: investment.isin || investment.tickerSymbol,
  ticker_symbol: investment.tickerSymbol,
  quoteProvider: investment.quoteProvider,
});
